import JSCookie from 'js-cookie';

export const getCookie = (key: string) => JSCookie.get(key);

export const deleteCookie = (key: string) => JSCookie.remove(key);

export const setCookie = (
  key: string,
  value: string = key,
  additionalParams?: Cookies.CookieAttributes
) => JSCookie.set(key, value, { expires: 1, ...additionalParams });
